/* eslint-disable react/jsx-one-expression-per-line */
import React, {Component} from 'react';
import {t, Trans} from '@lingui/macro';
import {DownOutlined} from '@ant-design/icons';
import {Dropdown} from 'antd';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import {Type} from "bukku/redux/Transaction/helper";
import { TooltipWrapper } from '../TolltipWrapper';
import BukkuEllipsisTag from '../../Tag';

dayjs.extend(isSameOrAfter);

/**
 * isView           : boolean      - true if it's in TransactionHeaderSubtitle.
 *                                 - false/null if in index.js status
 * overrideTermItems: TermItems[]  - used by TransactionHeaderSubtitle
 *                                 - as date is calculated onDemand in transactions' view
 */
export default class extends Component {
    constructor(props) {
        const {
            record,
            overrideTermItems, // used by TransactionHeaderSubtitle
            onClick,
        } = props;
        super(props);

        this.term_items = record.term_items;
        this.hideTooltip = props.hideTooltip;
        this.onClick = onClick || null;

        // parsing term_items based on view.js / index.js
        if (props.isView) {
            switch (record.type) {
                case Type.opening_invoice:
                case Type.opening_bill:
                case Type.opening_sale_credit_note:
                case Type.opening_purchase_credit_note:
                    this.term_items = [{date: record.date, amount: record.amount, balance: record.balance}];
                    break;
                default:
                    this.term_items = overrideTermItems || record.term_items;
                    break;
            }
        }
    }

    formatNumber = amount => amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

    getMenuItem = item => {
        const balance = this.formatNumber(item.balance);
        const date = dayjs(item.date).format("DD/MM/YYYY");
        const { record } = this.props;
        return (
            {
                key: item.id,
                label: (
                    <>
                        { record.currency_code }
                        { balance }&nbsp;on&nbsp;{ date }
                    </>
                ),
            }
        );
    };

    getTermsMenuItems = () => {
        const { record } = this.props;

        return record.term_items.map(this.getMenuItem);
    };

    // termsMenu = () => {
    //     const { record } = this.props;

    //     return (
    //         <Menu
    //             items={this.getTermsMenuItems()}
    //         />
    //     );
    // };

    renderDraft = () => (
        <TooltipWrapper title={t`Draft`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag
                color="purple"
                onClick={this.onClick}
            >
                <Trans>Draft</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    renderPendingApproval = () => (
        <TooltipWrapper title={t`Pending Approval`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag
                color="blue"
                onClick={this.onClick}
            >
                <Trans>Pending Approval</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    renderReady = () => {
        const { record } = this.props;

        switch (record.type) {
            case 'purchase_expense':
            case 'purchase_claim':
                return this.renderExpenseReady();
            case Type.sale_credit_note:
            case Type.opening_sale_credit_note:
            case Type.purchase_credit_note:
            case Type.opening_purchase_credit_note:
                return this.renderCreditNoteReady();
            case Type.sale_invoice:
            case Type.opening_invoice:
            case Type.purchase_bill:
            case Type.opening_bill:
            default:
                return this.renderInvoiceReady();
        }
    };

    renderPaid = () => (
        <TooltipWrapper title={t`Paid`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag
                color="green"
                onClick={this.onClick}
            >
                <Trans>Paid</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    renderComingDue = () => (

        <TooltipWrapper
            title={t`Coming Due`}
            hideTooltip={this.hideTooltip}
            autoAdjustOverflow={false}
        >
            <Dropdown
                // overlay={this.termsMenu}
                menu={{items: this.getTermsMenuItems()}}
                trigger={['hover', 'click']}
                getPopupContainer={trigger => trigger.parentElement}
                overlayStyle={{
                    minWidth: 'max-content',
                }}
                mouseEnterDelay={0.25}
                mouseLeaveDelay={0}
                // placement="top"
            >
                <BukkuEllipsisTag
                    color="orange"
                    onClick={this.onClick}
                >
                    <Trans>Coming Due</Trans>
                &nbsp;
                    <DownOutlined />
                </BukkuEllipsisTag>
            </Dropdown>
        </TooltipWrapper>
    );

    renderOverdue = () => (
        <TooltipWrapper
            title={t`Overdue`}
            hideTooltip={this.hideTooltip}
            autoAdjustOverflow={false}
        >
            <Dropdown
                // overlay={this.termsMenu}
                menu={{items: this.getTermsMenuItems()}}
                trigger={['hover', 'click']}
                getPopupContainer={trigger => trigger.parentElement}
                overlayStyle={{
                    minWidth: 'max-content',
                }}
                mouseEnterDelay={0.25}
                mouseLeaveDelay={0}
                // placement="top"
            >
                <BukkuEllipsisTag
                    color="red"
                    onClick={this.onClick}
                >
                    <Trans>Overdue</Trans>
                &nbsp;
                    <DownOutlined />
                </BukkuEllipsisTag>
            </Dropdown>
        </TooltipWrapper>
    );

    renderInvoiceReady = () => {
        const { record } = this.props;

        // Paid
        if (record.balance <= 0)
            return this.renderPaid();

        // Coming Due / Overdue
        const nextDueDayMoment = dayjs(this.term_items[0]?.date);
        const todayMoment = dayjs().startOf('day');
        if (nextDueDayMoment.isSameOrAfter(todayMoment))
            return this.renderComingDue();
        return this.renderOverdue();
    };

    renderCreditNoteReady = () => {
        const { record } = this.props;

        if (record.balance === 0)
            return this.renderApplied();
        return this.renderOutstanding();
    };

    renderExpenseReady = () => {
        const { record } = this.props;

        if (record.balance === 0)
            return this.renderPaid();
        return this.renderOutstanding();
    };

    renderApplied = () => (
        <TooltipWrapper title={t`Applied`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag
                color="green"
                onClick={this.onClick}
            >
                <Trans>Applied</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    renderOutstanding = () => (
        <TooltipWrapper title={t`Outstanding`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag
                color="red"
                onClick={this.onClick}
            >
                <Trans>Outstanding</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    renderVoid = () => (
        <TooltipWrapper title={t`Void`} hideTooltip={this.hideTooltip}>
            <BukkuEllipsisTag onClick={this.onClick}>
                <Trans>Void</Trans>
            </BukkuEllipsisTag>
        </TooltipWrapper>
    );

    render() {
        const {record} = this.props;

        switch (record.status) {
            case 'draft':
                return this.renderDraft();
            case 'pending_approval':
                return this.renderPendingApproval();
            case 'ready':
                return this.renderReady();
            case 'void':
                return this.renderVoid();
            default:
                return null;
        }
    }
}
